import { faMagnifyingGlass, faXmark } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { isNullOrUndefined, isEmptyString } from "base/utils";
import React, { useEffect, useState, useRef } from "react";

const RecipeSearchByIngredientIncluded = ({ recipes, onSearch, closeMenu }) => {
  const [buttonWidth, setButtonWidth] = useState(0);
  const [searchInput, setSearchInput] = useState("");
  const buttonRef = useRef(null);

  const handleChange = (e) => {
    setSearchInput(e.target.value);
    let filteredRecipes = recipes.filter((r) =>
      r.ingredients.some((i) =>
        i.name.toLowerCase().includes(searchInput.toLowerCase()),
      ),
    );
    onSearch(filteredRecipes);
  };

  const searchText = document.querySelector(
    '#Recipe-Search-By-Ingredient[type="search"]',
  );

  searchText?.addEventListener("search", (event) => {
    //using the clear from the input with type search to reset search
    if (event.target.value === "") {
      clearSearch();
    }
  });

  const clearSearch = () => {
    setSearchInput("");
    onSearch(recipes);
  };

  // Measure button width once after mount
  useEffect(() => {
    if (buttonRef.current) {
      setButtonWidth(buttonRef.current.offsetWidth);
    }
  }, []);

  return (
    <div>
      <input
        id="Recipe-Search-By-Ingredient"
        style={{ marginLeft: buttonWidth }}
        className="Search-By-Name"
        type="search"
        placeholder="Search by included ingredient"
        value={searchInput}
        onChange={handleChange}
      />
      {!isNullOrUndefined(searchInput) && !isEmptyString(searchInput) && (
        <button id="clear-text-field" type="button" onClick={clearSearch}>
          <FontAwesomeIcon className="fa-thin" icon={faXmark} />
        </button>
      )}
      <button
        ref={buttonRef}
        className="faking"
        onClick={closeMenu}
      >
        <FontAwesomeIcon className="fa-thin" icon={faMagnifyingGlass} />
      </button>
    </div>
  );
};

export default RecipeSearchByIngredientIncluded;
